<div class="switch-btn" (click)="switch()">{{text}}</div>
